import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import responsiveText from 'ui/styles/responsiveText'
import Button from 'ui/components/generic/Button'

const Wrapper = styled.section`
  margin-bottom: 85px;
`

const StyledRow = styled(Row)`
  margin-bottom: 60px;

  ${media.md`
    margin-bottom: 140px;
  `}
`

const TextContainer = styled(Col)`
  ${media.xs`
    order: 2;
  `}
`

const ImageContainer = styled(Col)`
  ${media.xs`
    order: 1;
    margin-bottom: 20px;
  `}
`

const Image = styled.img`
  width: 100%;
  display: block;
  margin-bottom: 40px;

  ${media.xs`
    margin-bottom: 0;
  `}

  ${media.md`
    margin-bottom: 0;
  `}
`

const Count = styled.span`
  color: ${props => props.theme.colors.primary};
  font-weight: 600;
  margin-bottom: 15px;
  display: block;
`

const Title = styled.h2`
  ${responsiveText('lg')}
  font-weight: 400;
`

const Text = styled.p`
  max-width: 600px;
  margin: 0 0 45px;
`

export default class TextAndImage extends Component {
  render() {
    const { blocks } = this.props

    return(
      <Wrapper>
        <Container fluid>
          {blocks.map((block, index) => {
            return(
              <StyledRow key={index}>
                <TextContainer
                  xsOrder={2}
                  sm={10}
                  smOffset={1}
                  smOrder={2}
                  md={5}
                  mdOffset={1}
                  mdOrder={block.alignment === 'left' ? 2 : 1}
                  >
                  <Count>{index + 1 < 10 ? `0${index + 1}` : index + 1}</Count>
                  <Title>{block.title}</Title>

                  {block.text &&
                    <Text>{block.text}</Text>
                  }

                  {block.link &&
                    <Button
                    link={block.link.url}
                    title={block.link.title}
                    />
                  }
                </TextContainer>
              
                <ImageContainer
                  xsOrder={1}
                  sm={10}
                  smOffset={1}
                  smOrder={1}
                  md={4}
                  mdOffset={1}
                  mdOrder={block.alignment === 'left' ? 1 : 2}
                >
                  <Image src={block.image.sourceUrl} />
                </ImageContainer>
              
              </StyledRow>
            )
          })}
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/TextAndImage/index.js